iScreenWizard.factory('Testtype', function ($q, Ajax) {

    var data = {};

    data.all = function() {
        return $q(function (resolve, reject) {
            Ajax.get('testtype').then(function (response) {
                var testtypes = response.data;
                resolve(testtypes);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('testtype/'+id).then(function (response) {
                var testtype = response.data;
                resolve(testtype);
            }, reject);
        });
    };

    return data;
});